import { CaseListQueryCase } from '.';

export class CaseListQueryResponse {
  errorCode: string;
  errorText: string;
  cases: CaseListQueryCase[];
}
